import React from 'react';

import {StepHeader} from 'src/components/step-header';

import {ENTITLEMENTS_SUB_TABS} from '../constants';
import {entitlementsSubTabTitle} from '../entitlements-subtab.module.styl';
import {EntitlementsTabBar} from '../entitlements-tabs';

import {McpUserEntitlementsTab} from './mcp-user-entitlements-tab';

type Props = {
    userId: number,
    accountId: number,
};

export const McpUserEntitlementsSubTab = ({userId, accountId}: Props) => (
    <>
        <EntitlementsTabBar
            userId={userId}
            activeSubTab={ENTITLEMENTS_SUB_TABS.MCP_ENTITLEMENTS.name}
        />
        <div className={entitlementsSubTabTitle}>
            <StepHeader title={ENTITLEMENTS_SUB_TABS.MCP_ENTITLEMENTS.caption}/>
        </div>
        <McpUserEntitlementsTab userId={userId} accountId={accountId}/>
    </>
);
